module.exports = __webpack_public_path__ + "static/img/cMRI3.59df4f18.png";